import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-z', 'IconLetterZ', [
  ['path', { d: 'M7 4h10l-10 16h10', key: 'svg-0' }],
]);
